import type { Component } from "svelte";

import { get, writable } from "svelte/store";

interface IDrawerOptions {
	closeOnContentClick?: boolean;
	from: "bottom" | "left";
	fullscreen?: boolean;
	onClose?: null | (() => void);
	componentProps?: any;
}

let component = writable<Component | null>();
let options = writable<IDrawerOptions>({
	fullscreen: false,
	closeOnContentClick: false,
	from: "bottom",
	onClose: null,
	componentProps: null
});

export function useDrawer() {
	function open(component_: Component, options_?: IDrawerOptions) {
		document.body.classList.add("overflow-hidden");
		if (component_ !== get(component)) {
			component.set(component_);
			if (options_) {
				options.set(options_);
			}
		} else {
			close();
		}
	}

	function close() {
		document.body.classList.remove("overflow-hidden");

		const optionsValue = get(options);
		if (optionsValue?.onClose) {
			optionsValue.onClose();
		}
		options.set({
			closeOnContentClick: false,
			from: "bottom"
		});
		component.set(null);
	}

	return { open, close, component, options };
}
